<template>
  <section>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="pagination"
      hide-default-footer
      class="dataTable"
      @page-count="pageCount = $event"
    >
      <tbody>
        <tr v-for="(item, index) in items" :key="'key' + index">
          <td>{{ item.name }}</td>
          <td class="text-xs-right">{{ item.count }}</td>
        </tr>
      </tbody>
    </v-data-table>
    <div v-show="pageCount > 1" class="text-center py -2">
      <v-pagination
        v-model="pagination.page"
        :length="pageCount"
      ></v-pagination>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array
    },
    items: {
      type: Array
    }
  },
  data() {
    return {
      pagination: {
        itemsPerPage: 10,
        sortBy: ['name'],
        sortDesc: [true]
      },
      pageCount: 0
    }
  }
}
</script>
